import axios from "axios";

const BAE_PATH = window.API_URL || process.env.VUE_APP_API_URL;

const knExploreAPI = process.env.VUE_APP_KN_EXPLORE_API_URL;

const VERSION = "";
export const API_URL = BAE_PATH + VERSION;
const MET_URL = process.env.VUE_APP_MET_URL;
var wildCards = {
  groupID: "{uidGroup}",
  periodID: "{uidPeriod}",
  periodIDInt: "{idPeriod}",
  userID: "{uidUser}",
  challengeID: "{uidChallenge}",
  classId: "{uidClass}",
  modelId: "{uidModel}",
  idPeriodSet: "{idPeriodSet}",
  eraseConfirm: "{eraseConfirm}",
  campusId: "{campusId}",
  levelId: "{levelId}",
  calculated_status: "{calculated_status}",
};

export const API_PATHS = {
  BASE: API_URL,
  MET: MET_URL + "api/v2/",
  OAUTH: "oauth2",
  USER: {
    GET_USER_OPTIONS: "users/getBySpringSecurity", // DEP160
  },
  CHALLENGE: {
    ENDPOINT: "challenges/",
    DETAILS: "followup/details", //DEP023
  },
  CLASSES: {
    ENDPOINT: "class-dep/",
    GROUPS: "my-groups", //DEP038
    GROUP_CHALLENGE_PATHWAY:
      "group/" + wildCards.groupID + "/challenge/" + wildCards.challengeID, //DEP039
    EVAL_STATUS: "multiple-eval-status", //DEP020
    CHALLENGE_PUBLISH: "multiple-class-published", //DEP021
    CHALLENGE_EVAL_PUBLISH: "publishByChallengeAndGroup", //DEP043
    CHALLENGE_PERIODS_WITH_SCORES: "periods/group", //DEP044
    CALCULATE_SCORE_CHALLENGE:
      "score/calculate/idChallenge/" +
      wildCards.challengeID +
      "/idGroup/" +
      wildCards.groupID, //DEP042
    CHANGE_OFICIAL_SCORE: "group-period-scores/editScore", //DEP052
    PERIOD_EVAL_PUBLISH:
      "group-periods/publishByCampusEvaluationPeriodAndGroup", //DEP0200

    SAVE_SCORE_FILES_CHALLENGE: "class-challenge-pathway/report-group", //DEP040
    GET_SCORE_BY_CHALLENGE:
      "group-challenge-scores/challenge/" +
      wildCards.challengeID +
      "/group/" +
      wildCards.groupID, //DEP046

    CALCULATE_SCORE_PERIOD:
      "evaluation/score/calculateOfficialSubjects/idCampusEvaluationPeriod/" +
      wildCards.periodID +
      "/idGroup/" +
      wildCards.groupID, //DEP026
    SAVE_SCORE_FILES_PERIOD: "campusEvaluationPeriodReport/save", //DEP041
    GET_SCORE_BY_PERIOD:
      "group-challenge-scores/campusEvaluationPeriod/" +
      wildCards.periodID +
      "/group/" +
      wildCards.groupID, //DEP047

    CHANGE_SCORE: "group-challenge-scores/edit-score", //DEP048

    GROUP_PERIOD_PATHWAY:
      "group-periods/group/" +
      wildCards.groupID +
      "/campusEvaluationPeriod/" +
      wildCards.periodID, //DEP045
    REVERT_SCORE: "group-challenge-scores/resetScores/", //DEP061
    REVERT_OFFICIAL_SCORE: "group-period-scores/resetScores/", //DEP060
    REVERT_CUSTOM_PATHWAY_SCORE: "local-pathway/reset-edition/", //DEP054
    REVERT_LOCAL_CRITERIA_SCORE: "group-local-scores/reset-edition/", //DEP053

    CHANGE_CUSTOM_SCORE: "local-pathway/editScores", //DEP064
    CHANGE_CRITERIA_SCORE: "group-local-scores/edit-score", //DEP063
    CHANGE_AVERAGE_SCORE: "group-period-scores/edit-average", //DEP099
  },
  FILTERS: {
    ENDPOINT: "filters", //DEP004
    FOLLOWUP: "/challenge-tracking", //DEP050
  },
  DOCUMENTS: {
    FOLDER: "documents/folder?idFolder=", //DEP024
    DOCUMENTS_ACKNOWLEDGEMENT:
      "userDocumentsAcknowledgement/hasTermsAndConditions", //DEP077
    ACCEPT_TERMNS_CONDITIONS: "userDocumentsAcknowledgement/termsAndConditions", //DEP076
  },
  GRADE_REPORT: {
    PARENT_CHILDREN_LIST: "/userRelatives/getByUUIDRelative/",
    SCORES: "/evaluation/score/knotionSubjects/idChallenge/",
    // KNOTION_SCORES: `/evaluation/score/knotionSubjects/idChallenge/${wildCards.challengeID}/idUser/${wildCards.userID}`, //DEP094 -> EV0193
    //OFFICIAL_SCORES_BY_CHALLENGE: `evaluation/card/officialSubjects/idChallenge/${wildCards.challengeID}/idUser/${wildCards.userID}`, //DEP095 -> EV0194
    // OFFICIAL_SCORES_BY_PERIOD: `evaluation/card/officialSubjects/idCampusEvaluationPeriod/${wildCards.periodID}/idUser/${wildCards.userID}`, //DEP098 ->
    CHALLENGE_PERIODS_GROUP: `/evaluation/card/officialSubjects/idUser/${wildCards.userID}/filter?idPeriod=${wildCards.periodID}`, //DEP093
    CHALLENGE: {
      DATA_STUDENT: `/evaluation/challenge/${wildCards.challengeID}/user/${wildCards.userID}/header-info`, //EV0191
      REPORT_STUDENT_STATUS: `/evaluation/challenge/${wildCards.challengeID}/user/${wildCards.userID}/cards`, //EV0192
      SUBJECTS_KNOTION_SCORES: `/evaluation/challenge/${wildCards.challengeID}/user/${wildCards.userID}/knotion-subjects-scores?calculated=${wildCards.calculated_status}`, //EV0193
      SUBJECTS_OFFICIAL_SCORES: `/evaluation/challenge/${wildCards.challengeID}/user/${wildCards.userID}/official-subjects-scores?calculated=${wildCards.calculated_status}`, //EV0194

      SUBJECTS_OFFICIAL_SCORES_GROUPED: (
        challengeID,
        userID,
        calculated_status
      ) =>
        `/evaluation/challenge/${challengeID}/user/${userID}/formative-fields?calculated=${calculated_status}`, //EV0194.1

      SUBJECTS_CUSTOM_SCORES: `/evaluation/challenge/${wildCards.challengeID}/user/${wildCards.userID}/custom-subjects-scores?calculated=${wildCards.calculated_status}`, //EV0195
      LOCAL_PATHWAYS_SCORES: `/evaluation/challenge/${wildCards.challengeID}/user/${wildCards.userID}/local-pathways-scores?calculated=${wildCards.calculated_status}`, //EV0196
      LOCAL_CRITERIAS_SCORES: `/evaluation/challenge/${wildCards.challengeID}/user/${wildCards.userID}/local-criterias-scores?calculated=${wildCards.calculated_status}`, //EV0197
      HISTORIC_REPORT: `evaluation/score/knotionSubjectsHistoric/generateHistoricReport`, //DEP014,
      PRINTED_REPORT: `class-challenge-pathway/report-user-knotion`, //DEP096
      CHALLENGE_LIST: "/challenges/user/", //DEP027
    },
    PERIOD: {
      DATA_STUDENT: `/evaluation/campusEvaluationPeriod/${wildCards.periodID}/user/${wildCards.userID}/header-info`, //EV0198
      REPORT_STUDENT_STATUS: `/evaluation/campusEvaluationPeriod/${wildCards.periodID}/user/${wildCards.userID}/cards`, //EV0199
      SUBJECTS_KNOTION_SCORES: `/evaluation/campusEvaluationPeriod/${wildCards.periodID}/user/${wildCards.userID}/knotion-subjects-scores?calculated=${wildCards.calculated_status}`, //EV0200
      SUBJECTS_OFFICIAL_SCORES: `/evaluation/campusEvaluationPeriod/${wildCards.periodID}/user/${wildCards.userID}/official-subjects-scores?calculated=${wildCards.calculated_status}`, //EV0201

      SUBJECTS_OFFICIAL_SCORES_GROUPED: (
        challengeID,
        userID,
        calculated_status
      ) =>
        `/evaluation/campus-evaluation-period/${challengeID}/user/${userID}/formative-fields?calculated=${calculated_status}`, //EV0201.1

      SUBJECTS_CUSTOM_SCORES: `/evaluation/campusEvaluationPeriod/${wildCards.periodID}/user/${wildCards.userID}/custom-subjects-scores?calculated=${wildCards.calculated_status}`, //EV0202
      LOCAL_PATHWAYS_SCORES: `/evaluation/campusEvaluationPeriod/${wildCards.periodID}/user/${wildCards.userID}/local-pathways-scores?calculated=${wildCards.calculated_status}`, //EV0203
      LOCAL_CRITERIAS_SCORES: `/evaluation/campusEvaluationPeriod/${wildCards.periodID}/user/${wildCards.userID}/local-criterias-scores?calculated=${wildCards.calculated_status}`, //EV0204
      HISTORIC_REPORT: `evaluation/score/knotionSubjectsHistoric/generateHistoricReportOfficialSubject`, //DEP0201
      PRINTED_REPORT: `evaluation/score/generate-individual/reportcard-official`, //DEP0202
    },
  },
  CUSTOM_SUBJECTS: {
    ENDPOINT: "custom-subject",
  },
  WEBON_TABLES: {
    USERS: "/users",
    STUDENTS: `/classStudents/getStudents`,
    STUDENTS_BY_PERIOD: "/users/getStudentsBy/idPeriodInt/", //DEP015
    CLASSES: "/knotionClass/getClassesByIdCampus/", //DEP009
    GROUPS: "/groups/idPeriod/", //DEP108
    CLASSES_WIZARD: "/knotionClass/classesWizard",
    INSTITUTIONAL_CRITERIAS: "/evaluationLocalCriteria/campus/", //DEP031
    PERIOD_SETS: "/setperiod/list", //DEP086
    CUSTOM_SUBJECTS: "/custom-subject/find-by-idPeriod", //DEP142
    ASSIGN_CLASSES: "/knotionClass/to-assign",
    EVALUATION: {
      MODELS: "/evaluationLocalModels/period/", //DEP034
    },
    CALL_CENTER: {
      BANK_STATEMENTS: "callCenter/userStudents",
      TRANSACTIONS: "callcenter/transactions",
      RELATIVES: "users/user-relative",
      STUDENTS: "users/getUserCallCenter",
      STUDENTS_PAYMENT_FORM: "users/find-status-payment-students-by-filters",
      RELATIVES_TABLE: "relatives/find-by-fullName",
    },
  },
  CLASSES_SECTION: {
    WIZARD_DETAIL: "/knotionClass/wizard/detail/",
    WIZARD_IGNORE_CLASS: "/knotionClass/wizard/changeStatus/",
    WIZARD_PROCESS_CLASS: "/knotionClass/wizard/asocciateUsersToClass",
    WIZARD_PROCESS_ALL: "/knotionClass/wizard/associateAllClasses",
    SET_CLASS_STATUS: "/knotionClass/change-class-status?active=", //DEP008
    SET_ORDER: "/knotionClass/updateOrder",
    CLASS_DETAIL: `/knotionClass/getClass/idClass/${wildCards.classId}/readOnly`,
    SET_STUDENTS_ORDER: `/classStudents/saveOrderStudents/idClass/${wildCards.classId}`,
    SAVE_CLASS: `/knotionClass/saveClass`, //DEP088
    IMAGE_UPLOAD: "/upload/imageClass", //DEP089
    //BUSQUEDA AVANZADA
    EVALUATION_MODELS_LIST:
      "/evaluationModel/getEvaluationModelByCampus/idCampus/",
    LANGUAGE_LIST: "/languages/getLanguages",
    COACHES_LIST: "/users/getUserCoach?idCampus=",
    COORDINATORS_LIST: "/users/getUserCoordinator?idCampus=",
    STUDENTS_LIST: "/users/getStudentsByCampus",
    SAVE_CUSTOM_CLASS: "/knotionClass/custom", //DEP125
    SET_MASSIVE_STUDENTS_ORDER: "/knotionClass/orderStudents",
    SET_MASSIVE_ATTENDANCE_LIST:
      "/knotionClass/update-attendancelist-and-officialReportCard", //DEP0147
    ALLOW_CHAT: "/knotionClass/update-allowChat", //DEP161
  },
  CONFIGURATION: {
    EREPORT_DISPLAY: {
      //EVALUATION REPORT VISIBILITY
      /* DISPLAY_LIST : '/levels/campus', //DEP003
                  DISPLAY_SET : '/evaluation/group/evaluationVisibility', */

      SAVE_CONFIGURATION:
        "setperiod/saveConfiguration?idPeriod=" + wildCards.periodID, //DEP090
      PERIOD_SETS_LIST: "setperiod/gradeList?idPeriod=" + wildCards.periodID, //DEP091
      GET_CONFIGURATION:
        "setperiod/configuration?idPeriod=" + wildCards.periodID, //DEP092
    },
    INSTITUTIONAL_CRITERIAS: {
      SCALES_LIST: "/evaluationScale/types", //DEP030
      SAVE_INSTITUTIONAL_CRITERIA: "/evaluationLocalCriteria", //DEP032
      DELETE_INSTITUTIONAL_CRITERIA: "/evaluationLocalCriteria/delete", //DEP033
    },
    PERIOD_SETS: {
      SET_PERIOD: "/setperiod?eraseScores=true", //DEP083
      DELETE_PERIOD: `/setperiod/delete/${wildCards.idPeriodSet}?eraseScores=${wildCards.eraseConfirm}`, //DEP049
      DETAIL_PERIOD: `/setperiod/detail/${wildCards.idPeriodSet}`, //DEP085
    },
    GENERAL_CONFIGURATION: {
      PERMISSIONS_OF_CAMPUS: "/permissions/general/campusModules?idCampus=",
      SAVE_PERMISSIONS_OF_CAMPUS: "/permissions/save?idCampus=",

      PERMISSIONS_OF_CAMPUS_KNCHAT:
        "permissions/knChat/campusModules?idCampus=",

      GET_NOTIFICATIONS_SCHEDULE: "/schedule/campusSchedule?idCampus=",
      SAVE_NOTIFICATIONS_SCHEDULE: "/schedule/save?idCampus=",
      SAVE_NOTIFICATIONS_SCHEDULE_RELATIVE: "/relativesSchedule/save?idCampus=", //DEP0180 - Save Relatives Schedule
      SAVE_KN_CARE_EMAILS: "/moduleEmail/save?idCampus=",
      SAVE_STORAGE_CONFIGURATION: "/campus/storage-configuration", // DEP163
      //api2.0/kn-explore/black-list
      GET_LEVELS_BY_USER_KN_EXPLORE: "/api2.0/kn-explore/levels",
      GET_CONFIG_BY_LEVEL_KN_EXPLORE: (levelId) =>
        `/api2.0/kn-explore/level/${levelId}/student-visibility-settings`,
      GET_CONFIG_BY_STAFF: "/api2.0/kn-explore/staff-visibility-settings",
      STORE_CONFIG_KN_EXPLORE: "/api2.0/kn-explore/visibility-settings",
      STORE_CONFIG_ENGINE_KN_EXPLORE: "/api2.0/kn-explore/search-engine",
      STORE_BOOKMARK_KN_EXPLORE: "/api2.0/kn-explore/bookmarks",
      GET_WHITE_LIST_STUDENT: (idLevel) =>
        `/api2.0/kn-explore/level/${idLevel}/student-white-list`,
      GET_BLACK_LIST_STUDENT: (idLevel) =>
        `/api2.0/kn-explore/level/${idLevel}/student-black-list`,
      GET_WHITE_LIST_BY_STAFF: "/api2.0/kn-explore/staff-white-list",
      GET_BLACK_LIST_BY_STAFF: "/api2.0/kn-explore/staff-black-list",
      STORE_WHITE_LIST_STUDENT: `/api2.0/kn-explore/white-list`,
      STORE_BLACK_LIST_STUDENT: `/api2.0/kn-explore/black-list`,
      DELETE_BLACK_LIST_DOMAIN: (idCampusPageBlackList) =>
        `/api2.0/kn-explore/${idCampusPageBlackList}/black-list`,
      DELETE_WHITE_LIST_DOMAIN: (idCampusPageWhiteList) =>
        `/api2.0/kn-explore/${idCampusPageWhiteList}/white-list`,
    },
    ATTENDACE_LIST: {
      GET_CONFIG: "class-attendances/configuration", //DEP0152
      SAVE_DELAYS: "campus-level-delay", //DEP0148
    },
    SUBJECTS: {
      GET_CONFIG: `/levels/campus/${wildCards.campusId}/period/${wildCards.idPeriodSet}/configuration-cards`, //DEP0215
      SET_CONFIG: "/levels/configuration-cards", //DEP0214
    },
  },
  EVALUATION: {
    MODELS: {
      DELETE_MODELS: "/evaluationLocalModels", //DEP035
      MODEL_DETAIL: "/evaluationLocalModels/" + wildCards.modelId, //DEP037
      SAVE_MODEL: "/evaluationLocalModels", //DEP036
    },
  },
  GROUPS_SECTION: {
    DELETE_GROUPS: "/groups/delete",
    PROMOTE: "/groupStudents/promote", // DEP107
    GROUP_DETAIL:
      "/groups/" + wildCards.groupID + "/idPeriod/" + wildCards.periodID,
    LEVES_FILTERS: `/levels/campus/${wildCards.campusId}?include-paths=true`, //DEP010
    SAVE_GROUP: "/groups", //DEP016
    GRADUATE: "/users/graduate-students", //DEP103
  },
  USERS: {
    ENDPOINT: "users",
    WEBON_TABLE: "/findByFilters",
    SET_USER_STATUS: "/status",
    DELETE: "/changeStatusDeleted/",
    MASIVE_DELETE: "/changeStatusDelete/",
    MASIVE_ACTIVE: "/changeStatusActive/",
    MASIVE_INACTIVE: "/changeStatusInactive/",
    USER_DETAIL:
      "/read-info/" + wildCards.userID + "/idPeriod/" + wildCards.periodIDInt, //DEP080
    ASIGN_CLASS: "/knotionClass/associateStudentClass",
    ASIGN_GROUP: "/groups/changeOrAssociteStudent",
    IMPORT_STUDENTS: "/import/students",
    IMPORT_COACH: "/import/coaches",
    PAYMENT_STATUS: "/filters/paymentStatus",
    PATHWAYS: "/filters/classes",
    UPLOAD_AVATAR: "/upload/avatarUpload",
    UPLOAD_PUBLIC_AVATAR: "/upload/publicAvatarUpload",
    READ: "/read/", //DEP0132
    USER_NAME_EXISTS: "/existUserName",
    EMAIL_EXISTS: "/existEmail",
    DROPOUT: "/dropout-student",
    EXPORT_USERS: "/exportUsers", // Deprecated, use above
    EXPORT_SELECTED_USERS: "/exportSelectedUsers", // DEP162
    PAYMENT_BALANCE: "payments/balance/getInfoPerStudents", //DEP116
    PROMOTE_STAFF: "/coord-coach/promote",
    DISASSOCIATE_RELATIVE: "userRelatives/delete", // DEP0181
    FORCE_CLOSE_SESSION: "users/force-logout", // DEP136
    RESET_APP: "users/restart-ipad",
    DROPOUT_STUDENTS: "users/dropout-students",
    GET_CAMPUS_BY_COUNTRY: (countryId) =>
      `campus/orderByName?idCountry=${countryId}`,
  },
  PAYMENTS: {
    TYPES: "/paymentTypes", //DEP019
    GENERATE: "payments/bank/getPayment/callcenter", //DEP117
  },
  CATALOGS: {
    MEXICO_STATES: "/states/sysVariable/",
    MEXICO_CITIES: "/cities/state/",
    USER_TYPES: "/userTypes/edu",
    RELATIONSHIP_TYPES: "relationships",
    CAMPUS_LEVELS: "levels/campus/ligth/", //DEP011
    DISMISS_REASONS: "dismissReasons", //DEP101
    PERIODS: "campusActivePeriods/findByCampus",
    IMPACT_AVATAR: "/avatars", //DEP139
  },
  UTIL: {
    GET_CAMPUS_OBJECT: "campus/",
  },
  STUDENTS_FORM: {
    LEVELS_LIGHT: `/levels/campus/ligth/${wildCards.campusId}`, //DEP011
    USERNAME_GENERATION: `/users/student/generateUsername?`,
    SAVE: `/users/students/period/${wildCards.periodID}`,
  },
  NOTIFICATIONS: {
    LIST: "pushNotificationScheduled/list", //DEP113
    MULTICAMPUS_LIST: "pushNotificationCommunication/list", //DEP135
    SAVE: "pushNotificationScheduled", //DEP110
    MULTICAMPUS_SAVE: "pushNotificationCommunication", //DEP110
    GROUP_SCHEUDLE: "pushNotificationScheduledGroups/combination", //DEP120
    DELETE: "pushNotificationScheduled/delete", //DEP112
    DELETE_MASIVE: "pushNotificationCommunication/delete", //DEP139 🙄 me encanta duplicar código....
    USER_SCHEDULE: "users/notifications", //DEP114 usuarios que pueden recibir notificaciones
    USER_MULTICAMPUS_SCHEDULE: "users/notificationsmulticampus", //DEP134
    FILTERS: "/filters/notificationList", //DEP126
    MULTI_CAMPUS_FILTERS: "/multicampus", //DEP127 DEP0130
    SEND_FILTERS: "/filters/notification", //DEP109
  },
  CALL_CENTER: {
    TRANSACTIONS: "callcenter/transactions/generalInfo",
    GET_PAYMENT_DETAILS: (paymentId) =>
      `payments/balance/getInfoPerPay/${paymentId}`,
    GET_PAYMENT_CANCELLATION_DETAIL: (paymentId) =>
      `payments/detail/${paymentId}?addTransactions=true&isForCancellation=true`,
    BANK_STATEMENT_DETAIL: (userId, periodId, paymentDepositSheetType) =>
      `payments/getPaymentsByUser/idUser/${userId}/idPeriod/${periodId}?idPaymentDepositSheetType=${paymentDepositSheetType}`,
    SEND_PAYMENT_INVOICE_BY_EMAIL:
      "/callcenter/sendMailPaymentInvoiceGenerated",
    SEND_PAYMENT_VOUCHER_BY_EMAIL:
      "/payments/callCenterPayment/sendConfirmedEmail",
    SEND_PAYMENT_FORM_BY_EMAIL: (emailAddress) =>
      `/payments/callCenterPayment/sendEmail?email=${emailAddress}`,
    GET_PAYMENT_TYPES: "/paymentTypes",
    GENERATE_OXXO_PAYMENT_FORM: (paymentId) =>
      `payments/paymentMethod/${paymentId}/idRelative/null/oxxoPay`,
    GET_OXXO_PAYMENT_INFO: (paymentId) =>
      `/payments/getInfoOxxo/idPayment/${paymentId}`,
    GENERATE_BANK_TRANSFER_FORM:
      "/payments/callcenter/bancomer/generate-deposit-sheet",
    ADD_RELATIVE: "/payments/associate-payment-to-relative",
    USER_PAYMENT_CONFIGURATION: "/user-payment-configuration",
    GET_USER_PAYMENT_CONFIGURATION: (periodId, userId) =>
      `/user-discount/period/${periodId}/user/${userId}`,
    DELETE_PAYMENT_CONFIGURATION: (periodId, userId) =>
      `/user-payment-configuration/period/${periodId}/user/${userId}/discount`,
    CANCEL_PAYMENT: "/paymentCancellation",
    PAYMENT_CANCELLATION_DETAIL: (paymentId) =>
      `/paymentCancellation/payment/${paymentId}`,
    PAYMENY_CANCELLATION_PROCESS_DETAIL: (paymentId) =>
      `/payments/detail-cancellation-in-process/${paymentId}?addTransactions=false`,
    NEW_PAYMENT_MODAL: {
      UPLOAD_PAYMENT_FILE: "voucher/upload-file",
      DELETE_FILES: "voucher/files",
      SAT_PAYMENT_TYPES: "payment-type-sat/all",
      GET_PAYMENT_AMOUNT_BY_DATE_FOR_STUDENTS:
        "payments/payment-amount-by-date",
      SAVE_PAYMENT: "payments/cat",
    },
    CANCELLATION_VOUCHERS: {
      UPLOAD_INVOICE_VOUCHER: (paymentId) =>
        `paymentCancellationDocument/import-voucher-cancellation-invoice/payment/${paymentId}`,
      UPLOAD_REFUND_VOUCHER: (paymentId) =>
        `paymentCancellationDocument/voucher-cancellation-refund/payment/${paymentId}`,
      COMPLETE_INVOICE_VOUCHER: (paymentId) =>
        `paymentCancellation/change-is-complete-voucher-invoice/${paymentId}`,
      COMPLETE_REFUND_VOUCHER: (paymentId) =>
        `paymentCancellation/change-is-complete-voucher-refund/${paymentId}`,
    },
    RELATIVE_CREATION: {
      CREATE_RELATIVE: "users/saveRelative",
      SAVE_INVOICE_INFORMATION: "invoiceInfos/save",
      SAVE_SHIPMENT_INFORMATION: "shipmentInformation/save",
      SAVE_STUDENTS_ASSOCIATION: (relativeId) =>
        `userRelatives/tutor/${relativeId}`,
    },
    FILTERS: {
      ACTIVE_CAMPUSES: "campus/actives",
      CAMPUS_LEVELS: (campusId) => `levels/campus/ligth/${campusId}`,
      COUNTRIES: "countries/orderByName",
      STATES_BY_COUNTRY: (countryId) => `states/country/${countryId}`,
      CITIES_BY_STATE: (stateId) => `cities/state/${stateId}`,
      SCHOOLS: (countryId) => `schools/orderByName?idCountry=${countryId}`,
      COMPANIES: (countryId) => `companies/orderByName?idCountry=${countryId}`,
      CAMPUSES_BY_COMPANY_AND_COUNTRY: (countryId, companyId) =>
        `campus/orderByName?idCompany=${companyId}&idCountry=${countryId}`,
      CAMPUSES: (schoolId) => `campus/school/${schoolId}`,
      PERIODS: (countryId) => `periods/orderByName?idCountry=${countryId}`,
      PERIODS_BY_STUDENT: (studentId) => `periods/student/${studentId}`,
      DISCOUNT_REASONS: "discount-reason",
      PRICES_BY_PERIOD_AND_USER: (periodId, userId) =>
        `payments/period/${periodId}/user/${userId}/early-prices`,
      ACTIVE_CANCELLATION_REASONS: "reasonCancellation/actives",
      BANKS_CATALOG: "banks",
      RELATIVE_EMAILS_BY_USER_ID: (userId) => `relatives/student/${userId}`,
    },
    CFDI: {
      PERSON_KINDS: "kind-of-person/find-all",
      USES: (personKind) => `use-cfdi/kind-of-person/${personKind}`,
      TAX_REGIMENS: (personKind, cfdiUse) =>
        `tax-regime/kind-of-person/${personKind}/use-cfdi/${cfdiUse}`,
    },
  },
  BECAS: {
    GET_BECAS_LIST: "becas/list",
  },
  KN_EXPLORE: {
    levels: (periodId, campusId) =>
      `/filters?idPeriod=${periodId}&idCampus=${campusId}`,
    getStudensByGroup: (campusId, periodId) =>
      `/classStudents/getStudents?idCampus=${campusId}&idPeriodInt=${periodId}`,
    getHistoryOfStudentsByIds: `/api2.0/kn-explore/user-page-log`,
    getCategoryOfURLKnExplore: `/api2.0/kn-explore/page-categories`,
    getSearchEnginesKnExplore: `/api2.0/kn-explore/search-engine-catalog`,
    getEnginesStudentKnExplore: `/api2.0/kn-explore/student-search-engine`,
    getEnginesStaffKnExplore: `/api2.0/kn-explore/staff-search-engine`,
    deleteBookmarkCategoryEndpoint: `/api2.0/kn-explore/category/delete-category`,
    getBookmarksEndpoint: `/api2.0/kn-explore/bookmarks`,
    getCampusBookmarksEndpoint: `/api2.0/kn-explore/campus-bookmarks`,
    deleteEnginesKnExplore: (idEngineUser) =>
      `/api2.0/kn-explore/${idEngineUser}/search-engine`,
    getBookmarksByGradeEndpoint: (idGrade) =>
      `/api2.0/kn-explore/grade/${idGrade}/bookmarks`,
    deleteBookmarkEndpoint: (idBookmark) =>
      `/api2.0/kn-explore/${idBookmark}/bookmarks`,
  },
};

export default function (store) {
  const dep = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
    },
  });

  const depKnExplore = axios.create({
    baseURL: knExploreAPI,
    headers: {
      "Content-Type": "application/json",
      Authorization: store.getters["User/token"],
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
    },
  });

  dep.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  const met2 = axios.create({
    baseURL: API_PATHS.MET,
    headers: {
      "Content-Type": "application/json",
    },
  });

  function objectToFormData(obj) {
    var form_data = new FormData();

    for (var key in obj) {
      if (Array.isArray(obj[key])) {
        for (let i = 0; i < obj[key].length; i++) {
          form_data.append(key + "[" + i + "]", obj[key][i]);
        }
      } else {
        form_data.append(key, obj[key]);
      }
    }

    return form_data;
  }

  const API = {
    oauth: {
      getToken(username, password) {
        const fdata = new URLSearchParams();
        fdata.append("username", username);
        fdata.append("password", password);
        fdata.append("grant_type", "password");
        return axios({
          method: "post",
          url: "https://knotion-api-dep.knotion.com/oauth/token",
          data: fdata,
          withCredentials: false,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            authorization:
              "Basic a25vdGlvbi1kZXA6RDFnMXQ0bEVkdWM0dDFvblBsNHRmb3Jt",
          },
        });
      },
    },
    util: {
      getCampusData(campus) {
        return dep
          .get(API_PATHS.UTIL.GET_CAMPUS_OBJECT + (campus ? campus : ""))
          .then((res) => {
            return res.data;
          });
      },
      getUserOptions() {
        return dep.get(API_PATHS.USER.GET_USER_OPTIONS);
      },
    },
    catalogs: {
      getAvatars() {
        return dep.get(API_PATHS.CATALOGS.IMPACT_AVATAR).then((res) => {
          return res.data;
        });
      },
      getPeriods() {
        return dep.get(API_PATHS.CATALOGS.PERIODS).then((res) => {
          return res.data;
        });
      },
      getCampusLevels(idCampus, showPathways) {
        return dep
          .get(
            API_PATHS.CATALOGS.CAMPUS_LEVELS +
              idCampus +
              "?include-paths=" +
              !!showPathways +
              "&idPeriod=" +
              store.state.period.idPeriod
          )
          .then((res) => {
            return res.data;
          });
      },
      getRelationshipTypes() {
        return dep.get(API_PATHS.CATALOGS.RELATIONSHIP_TYPES).then((res) => {
          return res.data;
        });
      },
      getUserTypes() {
        return dep.get(API_PATHS.CATALOGS.USER_TYPES).then((res) => {
          return res.data;
        });
      },
      getStates() {
        return dep
          .get(API_PATHS.CATALOGS.MEXICO_STATES + store.state.User.country)
          .then((res) => {
            return res.data;
          });
      },
      getCities(state) {
        return dep.get(API_PATHS.CATALOGS.MEXICO_CITIES + state).then((res) => {
          return res.data;
        });
      },
    },
    payments: {
      getPaymentTypes() {
        return dep.get(API_PATHS.PAYMENTS.TYPES).then((res) => {
          return res.data;
        });
      },
    },
    users: {
      generatePayment(studentWithPayments) {
        return dep
          .post(API_PATHS.PAYMENTS.GENERATE, studentWithPayments)
          .then((res) => {
            return res.data;
          });
      },
      getStudentBalance(idStudent) {
        return dep
          .post(API_PATHS.USERS.PAYMENT_BALANCE, [idStudent])
          .then((res) => {
            return res.data;
          });
      },
      dropoutStudent(idStudent, idDismissReason, comment) {
        return dep.post(API_PATHS.USERS.ENDPOINT + API_PATHS.USERS.DROPOUT, {
          idUser: idStudent,
          idDismissReason: idDismissReason,
          comment: comment || "",
        });
      },
      getDismissReasons() {
        //DEP101
        return dep.get(API_PATHS.CATALOGS.DISMISS_REASONS).then((res) => {
          return res.data;
        });
      },
      uploadAvatar: function (data) {
        return dep.post(API_PATHS.USERS.UPLOAD_AVATAR, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      },
      uploadPublicAvatar: function (data) {
        return dep.post(API_PATHS.USERS.UPLOAD_PUBLIC_AVATAR, data);
      },
      saveUser(userData) {
        return dep.post(API_PATHS.USERS.ENDPOINT, userData);
      },

      readUser(userID, periodIDInt) {
        //DEP0132
        const period = periodIDInt ? "?period=" + periodIDInt : "";
        return dep
          .get(
            API_PATHS.USERS.ENDPOINT + API_PATHS.USERS.READ + userID + period
          )
          .then((res) => {
            return res.data;
          });
      },
      userNameExists(username) {
        return dep
          .get(
            API_PATHS.USERS.ENDPOINT +
              API_PATHS.USERS.USER_NAME_EXISTS +
              "?userName=" +
              username
          )
          .then((res) => {
            return res.data;
          });
      },
      emailExists(email) {
        return dep
          .get(
            API_PATHS.USERS.ENDPOINT +
              API_PATHS.USERS.EMAIL_EXISTS +
              "?email=" +
              email
          )
          .then((res) => {
            return res.data;
          });
      },
      getPaymentStatus() {
        return dep.get(API_PATHS.USERS.PAYMENT_STATUS).then((res) => {
          return res.data;
        });
      },
      getPathways() {
        return dep.get(API_PATHS.USERS.PATHWAYS).then((res) => {
          return res.data;
        });
      },
      getCampusByCountry(countryId) {
        return dep
          .get(API_PATHS.USERS.GET_CAMPUS_BY_COUNTRY(countryId))
          .then((res) => {
            return res.data;
          });
      },
      asignGroup(students, idGroup, status) {
        let opData = {
          idGroup: idGroup,
          idPeriodInt: store.getters.idPeriodInt,
          idsStudents: students,
        };

        if (status) opData.status = "ASIGNAR";

        return dep.post(API_PATHS.USERS.ASIGN_GROUP, opData);
      },
      asignClasses(users, classes) {
        return dep.post(API_PATHS.USERS.ASIGN_CLASS, {
          students: users,
          classes: classes,
        });
      },
      getFilters() {
        //DEP0122
        return dep
          .get(
            API_PATHS.FILTERS.ENDPOINT +
              "?idPeriod=" +
              store.getters.idPeriod +
              "&idCampus=" +
              store.state.User.campus
          )
          .then((res) => {
            return res.data;
          });
      },
      deleteUser(user) {
        return dep.get(
          API_PATHS.USERS.ENDPOINT + API_PATHS.USERS.DELETE + user
        );
        // {"message":null,"hasUserNotDeleted":false,"totalStudentNotDeleted":null,"totalStudentDeleted":null}
      },
      changeUserStatus(idUser, status) {
        return dep.post(
          API_PATHS.USERS.ENDPOINT + API_PATHS.USERS.SET_USER_STATUS,
          {
            idUser: idUser,
            status: status,
          }
        );
      },
      masiveDelete(users) {
        return dep.post(
          API_PATHS.USERS.ENDPOINT + API_PATHS.USERS.MASIVE_DELETE,
          users
        );
      },
      masiveStatusActive(users) {
        return dep.post(
          API_PATHS.USERS.ENDPOINT +
            API_PATHS.USERS.MASIVE_ACTIVE +
            store.state.User.idInt,
          users
        );
      },
      masiveStatusInactive(users) {
        return dep.post(
          API_PATHS.USERS.ENDPOINT +
            API_PATHS.USERS.MASIVE_INACTIVE +
            store.state.User.idInt,
          users
        );
      },
      getUserDetails(user) {
        var url =
          API_PATHS.USERS.ENDPOINT +
          API_PATHS.USERS.USER_DETAIL.replace(wildCards.userID, user).replace(
            wildCards.periodIDInt,
            store.getters.idPeriodInt
          );
        return dep.get(url).then((res) => {
          return res.data;
        });
      },
      async exportSelectedUsers(users) {
        var url =
          API_URL +
          API_PATHS.USERS.ENDPOINT +
          API_PATHS.USERS.EXPORT_SELECTED_USERS;
        return await axios({
          url: url,
          method: "POST",
          responseType: "blob",
          data: users,
          headers: {
            "Content-Type": "application/json",
            Authorization: store.getters["User/token"],
            "Access-Control-Allow-Origin": "*",
          },
        }).then((response) => new Blob([response.data]));
      },
      promoteStaff(users) {
        var url =
          API_URL +
          API_PATHS.USERS.ENDPOINT +
          API_PATHS.USERS.PROMOTE_STAFF +
          "?idPeriod=" +
          store.getters.idPeriod;
        return dep.post(url, users);
      },
      disassociateRelative(idUserStudent, idUserRelative, idRelativeInt) {
        var url = API_URL + API_PATHS.USERS.DISASSOCIATE_RELATIVE;
        return dep.delete(url, {
          data: {
            idUserStudent,
            idUserRelative,
            idRelativeInt,
          },
        });
      },
      forceCloseSession(idsUser) {
        const url = `${API_URL}${API_PATHS.USERS.FORCE_CLOSE_SESSION}`;
        return dep.post(url, idsUser);
      },
      triggerResetApp(idsUser) {
        const url = `${API_URL}${API_PATHS.USERS.RESET_APP}`;
        return dep.post(url, idsUser);
      },
      dropoutStudents(
        students,
        idDismissReason,
        idPeriod = null,
        comment = null
      ) {
        const url = `${API_URL}${API_PATHS.USERS.DROPOUT_STUDENTS}`;

        return dep.post(url, {
          users: students,
          idDismissReason: idDismissReason, //requerido
          idPeriod: idPeriod, //opcional
          comment: comment, //opcional
        });
      },
    },
    followup: {
      getFilters() {
        return dep
          .get(
            API_PATHS.FILTERS.ENDPOINT +
              API_PATHS.FILTERS.FOLLOWUP +
              "?idPeriod=" +
              store.getters.idPeriod
          )
          .then((res) => {
            return res.data;
          });
      },
      getScoreNav(idGroup) {
        return dep
          .get(
            API_PATHS.CLASSES.ENDPOINT +
              API_PATHS.CLASSES.CHALLENGE_PERIODS_WITH_SCORES +
              "/" +
              idGroup +
              "?idPeriod=" +
              store.getters.idPeriod
          )
          .then((res) => {
            return res.data;
          });
      },
      publishChallengeGroupEval(pathwayChallenges) {
        return dep.post(
          API_PATHS.CLASSES.ENDPOINT + API_PATHS.CLASSES.CHALLENGE_EVAL_PUBLISH,
          pathwayChallenges
        );
      },
      publishPeriodGroupEval(periodData) {
        return dep.post(API_PATHS.CLASSES.PERIOD_EVAL_PUBLISH, periodData);
      },
      publishPathway(pathwayChallenges) {
        return dep.post(
          API_PATHS.CLASSES.ENDPOINT + API_PATHS.CLASSES.CHALLENGE_PUBLISH,
          pathwayChallenges
        );
      },
      evalStatus(pathwayChallenges) {
        return dep.post(
          API_PATHS.CLASSES.ENDPOINT + API_PATHS.CLASSES.EVAL_STATUS,
          pathwayChallenges
        );
      },
      getGroupChallengePathways(group, challenge) {
        var url =
          API_PATHS.CLASSES.ENDPOINT +
          API_PATHS.CLASSES.GROUP_CHALLENGE_PATHWAY.replace(
            wildCards.groupID,
            group
          ).replace(wildCards.challengeID, challenge);
        return dep.get(url).then((res) => {
          return res.data;
        });
      },
      getGroupPeriodPathways(group, period) {
        var url = API_PATHS.CLASSES.GROUP_PERIOD_PATHWAY.replace(
          wildCards.groupID,
          group
        ).replace(wildCards.periodID, period);
        return dep.get(url).then((res) => {
          return res.data;
        });
      },
      calculateReportChallenge(group, challenge) {
        var url =
          API_PATHS.CLASSES.ENDPOINT +
          API_PATHS.CLASSES.CALCULATE_SCORE_CHALLENGE.replace(
            wildCards.groupID,
            group
          ).replace(wildCards.challengeID, challenge);
        return dep.get(url);
      },

      saveScoreChallenge(group, challenge, withDetail) {
        return dep.post(API_PATHS.CLASSES.SAVE_SCORE_FILES_CHALLENGE, {
          idChallenge: challenge,
          idGroup: group,
          withDetail: withDetail,
        });
      },

      reportChallenge(group, challenge) {
        var url = API_PATHS.CLASSES.GET_SCORE_BY_CHALLENGE.replace(
          wildCards.groupID,
          group
        ).replace(wildCards.challengeID, challenge);
        return dep.get(url).then((res) => {
          return res.data;
        });
      },

      calculateReportPeriod(group, period) {
        var url = API_PATHS.CLASSES.CALCULATE_SCORE_PERIOD.replace(
          wildCards.groupID,
          group
        ).replace(wildCards.periodID, period);
        return dep.get(url);
      },

      saveScorePeriod(group, period, withDetail) {
        return dep.post(API_PATHS.CLASSES.SAVE_SCORE_FILES_PERIOD, {
          idCampusEvaluationPeriod: period,
          idGroup: group,
          withDetail: withDetail,
        });
      },

      reportPeriod(group, period) {
        var url = API_PATHS.CLASSES.GET_SCORE_BY_PERIOD.replace(
          wildCards.groupID,
          group
        ).replace(wildCards.periodID, period);
        return dep.get(url).then((res) => {
          return res.data;
        });
      },

      getClasses(filter) {
        //default filter
        var defaultFilter = {
          levels: [""],
          challenges: [1],
          grades: [],
          groups: [],
          idPeriod: store.getters.idPeriod,
        };

        if (!(filter instanceof Object)) filter = defaultFilter;

        if (!filter.idPeriod) filter.idPeriod = defaultFilter.idPeriod;

        return dep
          .post(
            API_PATHS.CHALLENGE.ENDPOINT + API_PATHS.CHALLENGE.DETAILS,
            filter
          )
          .then((res) => {
            return res.data;
          });
      },
      getGroups(filter) {
        var defaultFilter = {
          idLevel: "",
        };
        if (!(filter instanceof Object)) filter = {};

        return dep
          .post(
            API_PATHS.CLASSES.ENDPOINT +
              API_PATHS.CLASSES.GROUPS +
              "?idPeriod=" +
              store.getters.idPeriod,
            Object.assign(defaultFilter, filter)
          )
          .then((res) => {
            return res.data;
          });
      },

      changeScore(idGroup, idGroupChallengeScore, newScore, comment) {
        return dep
          .put(API_PATHS.CLASSES.CHANGE_SCORE, {
            idGroup: idGroup,
            idGroupChallengeScore: idGroupChallengeScore,
            newScore: newScore,
            comment: comment || "",
          })
          .then((res) => {
            return res.data;
          });
      },
      changeOfficialAverage(idGroupPeriodScore, newAverage, comment) {
        return dep
          .put(API_PATHS.CLASSES.CHANGE_AVERAGE_SCORE, {
            idGroupPeriodScore: idGroupPeriodScore,
            newAverage: newAverage,
            comment: comment || "",
          })
          .then((res) => {
            return res.data;
          });
      },
      changeOfficialScore(idGroupPeriodScore, newScore, comment) {
        return dep
          .put(
            API_PATHS.CLASSES.ENDPOINT + API_PATHS.CLASSES.CHANGE_OFICIAL_SCORE,
            {
              idGroupPeriodScore: idGroupPeriodScore,
              newScore: newScore,
              comment: comment || "",
            }
          )
          .then((res) => {
            return res.data;
          });
      },
      changeCustomScore(idEvaluationLocalPathwayScoreInt, newScore, comment) {
        return dep
          .put(API_PATHS.CLASSES.CHANGE_CUSTOM_SCORE, {
            idEvaluationLocalPathwayScoreInt: idEvaluationLocalPathwayScoreInt,
            newScore: newScore,
            comment: comment || "",
          })
          .then((res) => {
            return res.data;
          });
      },
      changeCriteriaScore(
        idGroupChallengeLocalCriteriaScoreInt,
        newScore,
        comment
      ) {
        return dep
          .put(API_PATHS.CLASSES.CHANGE_CRITERIA_SCORE, {
            idGroupChallengeLocalCriteriaScoreInt:
              idGroupChallengeLocalCriteriaScoreInt,
            newScore: newScore,
            comment: comment || "",
          })
          .then((res) => {
            return res.data;
          });
      },
      resetScore(idScore) {
        return dep.get(API_PATHS.CLASSES.REVERT_SCORE + idScore);
      },
      resetOfficialScore(idScore) {
        return dep.get(API_PATHS.CLASSES.REVERT_OFFICIAL_SCORE + idScore);
      },
      resetCustomScore(idScore) {
        return dep.get(API_PATHS.CLASSES.REVERT_CUSTOM_PATHWAY_SCORE + idScore);
      },
      resetCriteriaScore(idScore) {
        return dep.get(API_PATHS.CLASSES.REVERT_LOCAL_CRITERIA_SCORE + idScore);
      },
    },
    documents: {
      getDocuments: function (id, key, isExpanded = false) {
        return dep
          .get(
            API_PATHS.DOCUMENTS.FOLDER +
              (id ? id : "") +
              "&textSearch=" +
              (key ? key : "") +
              "&expanded=" +
              isExpanded
          )
          .then((res) => res);
      },
      getUserAknowledgement: function () {
        return dep.get(API_PATHS.DOCUMENTS.DOCUMENTS_ACKNOWLEDGEMENT);
      },
      saveUserAknowledgement: function (_termsData) {
        return dep.post(
          API_PATHS.DOCUMENTS.ACCEPT_TERMNS_CONDITIONS,
          _termsData
        );
      },
    },
    gradeReport: {
      getParentChildren: function (parentUuid) {
        return dep
          .get(API_PATHS.GRADE_REPORT.PARENT_CHILDREN_LIST + parentUuid)
          .then((res) => {
            return res.data;
          });
      },

      getScores: function (challengeId, userId) {
        return dep.get(
          API_PATHS.GRADE_REPORT.SCORES + challengeId + "/idUser/" + userId
        );
      },
      getChallengePeriodsList: function (idUser, periodId) {
        return dep.get(
          API_PATHS.GRADE_REPORT.CHALLENGE_PERIODS_GROUP.replace(
            wildCards.userID,
            idUser
          ).replace(wildCards.periodID, periodId)
        );
      },
      challenge: {
        getDataStudent: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.DATA_STUDENT.replace(
              wildCards.challengeID,
              challengeId
            ).replace(wildCards.userID, studentId)
          );
        },
        getReportStudentStatus: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.REPORT_STUDENT_STATUS.replace(
              wildCards.challengeID,
              challengeId
            ).replace(wildCards.userID, studentId)
          );
        },
        getSubjectsKnotionScores: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.SUBJECTS_KNOTION_SCORES.replace(
              wildCards.challengeID,
              challengeId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getSubjectsOfficialScores: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.SUBJECTS_OFFICIAL_SCORES.replace(
              wildCards.challengeID,
              challengeId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getSubjectsOfficialScoresGrouped: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.SUBJECTS_OFFICIAL_SCORES_GROUPED(
              challengeId,
              studentId,
              true
            )
          );
        },
        getSubjectsCustomScores: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.SUBJECTS_CUSTOM_SCORES.replace(
              wildCards.challengeID,
              challengeId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getLocalPathwaysScores: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.LOCAL_PATHWAYS_SCORES.replace(
              wildCards.challengeID,
              challengeId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getLocalCriteriaScores: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.LOCAL_CRITERIAS_SCORES.replace(
              wildCards.challengeID,
              challengeId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        generateHistoricReport: function (periodId, data) {
          return dep.post(
            API_PATHS.GRADE_REPORT.CHALLENGE.HISTORIC_REPORT +
              "?idPeriod=" +
              periodId,
            data
          );
        },
        generatePrintedReport: function (data) {
          return dep.post(
            API_PATHS.GRADE_REPORT.CHALLENGE.PRINTED_REPORT,
            data
          );
        },
        getChallengeList: function (idUser) {
          return dep.get(
            API_PATHS.GRADE_REPORT.CHALLENGE.CHALLENGE_LIST +
              idUser +
              "?lang=es"
          );
        },
      },
      period: {
        getDataStudent: function (periodId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.DATA_STUDENT.replace(
              wildCards.periodID,
              periodId
            ).replace(wildCards.userID, studentId)
          );
        },
        getReportStudentStatus: function (periodId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.REPORT_STUDENT_STATUS.replace(
              wildCards.periodID,
              periodId
            ).replace(wildCards.userID, studentId)
          );
        },
        getSubjectsKnotionScores: function (periodId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.SUBJECTS_KNOTION_SCORES.replace(
              wildCards.periodID,
              periodId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getSubjectsOfficialScores: function (periodId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.SUBJECTS_OFFICIAL_SCORES.replace(
              wildCards.periodID,
              periodId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getSubjectsOfficialScoresGrouped: function (challengeId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.SUBJECTS_OFFICIAL_SCORES_GROUPED(
              challengeId,
              studentId,
              true
            )
          );
        },
        getSubjectsCustomScores: function (periodId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.SUBJECTS_CUSTOM_SCORES.replace(
              wildCards.periodID,
              periodId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getLocalPathwaysScores: function (periodId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.LOCAL_PATHWAYS_SCORES.replace(
              wildCards.periodID,
              periodId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        getLocalCriteriaScores: function (periodId, studentId) {
          return dep.get(
            API_PATHS.GRADE_REPORT.PERIOD.LOCAL_CRITERIAS_SCORES.replace(
              wildCards.periodID,
              periodId
            )
              .replace(wildCards.userID, studentId)
              .replace(wildCards.calculated_status, true)
          );
        },
        generateHistoricReport: function (periodId, data) {
          return dep.post(
            API_PATHS.GRADE_REPORT.PERIOD.HISTORIC_REPORT +
              "?idPeriod=" +
              periodId,
            data
          );
        },
        generatePrintedReport: function (data) {
          return dep.post(API_PATHS.GRADE_REPORT.PERIOD.PRINTED_REPORT, data);
        },
      },
    },
    webonTable: {
      async getData(url, cancelToken) {
        return dep.get(url, {
          cancelToken: cancelToken ? cancelToken.token : null,
        });
      },
      postData: function (url, params, cancelToken) {
        return dep.post(url, params, {
          cancelToken: cancelToken ? cancelToken.token : null,
        });
      },
    },
    classes: {
      setAttendanceList: function (classes) {
        //DEP0147
        return dep.post(
          API_PATHS.CLASSES_SECTION.SET_MASSIVE_ATTENDANCE_LIST,
          classes
        );
      },
      getWizardDetail: function (classId) {
        return dep.get(API_PATHS.CLASSES_SECTION.WIZARD_DETAIL + classId);
      },
      ignoreClassInWizard: function (classId) {
        return dep.get(API_PATHS.CLASSES_SECTION.WIZARD_IGNORE_CLASS + classId);
      },
      processClassInWizard: function (classObject) {
        return dep.post(
          API_PATHS.CLASSES_SECTION.WIZARD_PROCESS_CLASS,
          classObject
        );
      },
      processAllClassesInWizard: function (filtersParameters) {
        return dep.post(
          API_PATHS.CLASSES_SECTION.WIZARD_PROCESS_ALL,
          filtersParameters
        );
      },
      changeClassStatus: function (status, classes, validatePathway = false) {
        return dep.post(
          API_PATHS.CLASSES_SECTION.SET_CLASS_STATUS +
            status +
            "&validatePathway=" +
            validatePathway,
          classes
        );
      },
      updateOrder: function (classes) {
        return dep.post(API_PATHS.CLASSES_SECTION.SET_ORDER, classes);
      },
      getClassDetail: function (idClass) {
        let url = API_PATHS.CLASSES_SECTION.CLASS_DETAIL.replace(
          wildCards.classId,
          idClass
        );
        return dep.post(url).then((res) => {
          return res.data;
        });
      },
      updateStudentsOrder: function (idClass, students) {
        return dep.post(
          API_PATHS.CLASSES_SECTION.SET_STUDENTS_ORDER.replace(
            wildCards.classId,
            idClass
          ),
          students
        );
      },
      setMassiveStudentOrder: function (sortOrder, classes) {
        return dep.post(API_PATHS.CLASSES_SECTION.SET_MASSIVE_STUDENTS_ORDER, {
          sortOrder: sortOrder,
          classes: classes,
        });
      },
      saveClass: function (classData) {
        return dep.post(API_PATHS.CLASSES_SECTION.SAVE_CLASS, classData);
      },
      uploadImage: function (data) {
        return dep.post(API_PATHS.CLASSES_SECTION.IMAGE_UPLOAD, data);
      },
      //Advanced Search
      ASLanguageList: function () {
        return dep.get(API_PATHS.CLASSES_SECTION.LANGUAGE_LIST);
      },
      ASCoachesList: function (campus) {
        return dep.get(API_PATHS.CLASSES_SECTION.COACHES_LIST + campus);
      },
      ASCoordinatorsList: function (campus) {
        return dep.get(API_PATHS.CLASSES_SECTION.COORDINATORS_LIST + campus);
      },
      ASStudentsList: function () {
        return dep.get(API_PATHS.CLASSES_SECTION.STUDENTS_LIST);
      },
      ASEvaluationModelsList: function (campus) {
        return dep.get(
          API_PATHS.CLASSES_SECTION.EVALUATION_MODELS_LIST + campus
        );
      },
      saveCustomClass: function (
        className,
        idLangInt,
        numberSessions,
        numberChallenges,
        groups,
        evalType
      ) {
        return dep.post(
          API_PATHS.CLASSES_SECTION.SAVE_CUSTOM_CLASS +
            "?idPeriod=" +
            store.getters.idPeriod,
          [
            {
              idsGroup: groups,
              classToSave: {
                name: className,
                idLanguageInt: idLangInt,
                evaluationType: evalType,
              },
              numberSessions: numberSessions,
              numberChallenges: numberChallenges,
            },
          ]
        );
      },
      /* allowChat function
       * param:classesList - Array de objetos para configurar el chat de las clases. Propiedades del objeto:
       *                      prop: idClass (uuid string)
       *                      prop: allowChat (bool)
       */
      allowChat: function (classesList) {
        return dep.post(API_PATHS.CLASSES_SECTION.ALLOW_CHAT, classesList);
      },
    },
    configuration: {
      /* getEReportDisplayList : function() {
                      return dep.get(API_PATHS.CONFIGURATION.EREPORT_DISPLAY.DISPLAY_LIST);
                  },
                  setEReportDisplay : function(eReportDisplayConfiguration) {
                      return dep.post(API_PATHS.CONFIGURATION.EREPORT_DISPLAY.DISPLAY_SET, eReportDisplayConfiguration);
                  }, */
      saveLevelDelays: function (levels) {
        //DEP0147
        return dep.post(
          API_PATHS.CONFIGURATION.ATTENDACE_LIST.SAVE_DELAYS,
          levels
        );
      },
      getAttendaceList() {
        return dep
          .get(
            API_PATHS.CONFIGURATION.ATTENDACE_LIST.GET_CONFIG +
              "?idPeriod=" +
              store.getters.idPeriod
          )
          .then((res) => {
            return res.data;
          });
      },
      getVisibilityConfiguration(idPeriod) {
        return dep
          .get(
            API_PATHS.CONFIGURATION.EREPORT_DISPLAY.GET_CONFIGURATION.replace(
              wildCards.periodID,
              idPeriod
            )
          )
          .then((res) => {
            return res.data;
          });
      },
      saveVisibilityConfiguration(config, idPeriod) {
        return dep.post(
          API_PATHS.CONFIGURATION.EREPORT_DISPLAY.SAVE_CONFIGURATION.replace(
            wildCards.periodID,
            idPeriod
          ),
          config
        );
      },
      getPeriodSetsList(idPeriod) {
        return dep
          .get(
            API_PATHS.CONFIGURATION.EREPORT_DISPLAY.PERIOD_SETS_LIST.replace(
              wildCards.periodID,
              idPeriod
            )
          )
          .then((res) => {
            return res.data;
          });
      },
      getScalesTypes: function () {
        return dep
          .get(API_PATHS.CONFIGURATION.INSTITUTIONAL_CRITERIAS.SCALES_LIST)
          .then((res) => {
            return res.data;
          });
      },
      saveInstitutionalCriteria: function (criteria) {
        return dep.post(
          API_PATHS.CONFIGURATION.INSTITUTIONAL_CRITERIAS
            .SAVE_INSTITUTIONAL_CRITERIA,
          criteria
        );
      },
      deleteInstitutionalCriteria: function (criteria) {
        return dep.delete(
          API_PATHS.CONFIGURATION.INSTITUTIONAL_CRITERIAS
            .DELETE_INSTITUTIONAL_CRITERIA,
          {
            data: [criteria],
          }
        );
      },
      setPeriodSet: function (set) {
        return dep.put(API_PATHS.CONFIGURATION.PERIOD_SETS.SET_PERIOD, set);
      },
      deletePeriodSet: function (idSet, confirmation) {
        return dep.get(
          API_PATHS.CONFIGURATION.PERIOD_SETS.DELETE_PERIOD.replace(
            wildCards.idPeriodSet,
            idSet
          ).replace(wildCards.eraseConfirm, confirmation)
        );
      },
      periodSetDetail: function (idPeriodSet) {
        return dep.get(
          API_PATHS.CONFIGURATION.PERIOD_SETS.DETAIL_PERIOD.replace(
            wildCards.idPeriodSet,
            idPeriodSet
          )
        );
      },
      getSubjects: (idCampus, idPeriodSet) => {
        return dep
          .get(
            API_PATHS.CONFIGURATION.SUBJECTS.GET_CONFIG.replace(
              wildCards.campusId,
              idCampus
            ).replace(wildCards.idPeriodSet, idPeriodSet)
          )
          .then((res) => {
            return res.data;
          });
      },
      setSubjects: (idPeriodSet, idCampus, config) => {
        return dep.post(API_PATHS.CONFIGURATION.SUBJECTS.SET_CONFIG, {
          idPeriod: idPeriodSet,
          idCampus: idCampus,
          levels: config,
        });
      },
    },
    generalConfiguration: {
      getPermissionsByCampus: function () {
        return dep.get(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.PERMISSIONS_OF_CAMPUS +
            store.state.User.campus
        );
      },
      getPermissionsByCampusknChat: function () {
        return dep.get(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
            .PERMISSIONS_OF_CAMPUS_KNCHAT + store.state.User.campus
        );
      },
      setPermissionsByCampus: function (data) {
        return dep.post(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
            .SAVE_PERMISSIONS_OF_CAMPUS + store.state.User.campus,
          data
        );
      },
      getNotificationSchedule() {
        return dep
          .get(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
              .GET_NOTIFICATIONS_SCHEDULE + store.state.User.campus
          )
          .then((res) => {
            return res.data;
          });
      },
      saveNotificationSchedule(modeuleData) {
        return dep.post(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
            .SAVE_NOTIFICATIONS_SCHEDULE + store.state.User.campus,
          modeuleData
        );
      },
      saveRelativeChatSchedule(modeuleData) {
        return dep.post(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
            .SAVE_NOTIFICATIONS_SCHEDULE_RELATIVE + store.state.User.campus,
          modeuleData
        );
      },
      saveCareEmails(modeuleData) {
        return dep.post(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.SAVE_KN_CARE_EMAILS +
            store.state.User.campus,
          modeuleData
        );
      },
      saveStorageConfiguration(moduleData) {
        return dep.post(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
            .SAVE_STORAGE_CONFIGURATION,
          moduleData
        );
      },
      getLevelsByUserKnExplore() {
        return depKnExplore.get(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
            .GET_LEVELS_BY_USER_KN_EXPLORE,
          {
            headers: {
              auth_key: store.state.User.uuid,
            },
          }
        );
      },
      getLevelsByCampusKnExplore(periodId, campusId) {
        return dep.get(API_PATHS.KN_EXPLORE.levels(periodId, campusId));
      },
      getCategoryOfURLKnExplore(data) {
        return depKnExplore.post(
          API_PATHS.KN_EXPLORE.getCategoryOfURLKnExplore,
          {
            ...data,
          },
          {
            headers: {
              auth_key: store.state.User.uuid,
              "Content-Type": "application/json",
            },
          }
        );
      },
      getStudensByGroupKnExplore(periodId, campusId, data) {
        return dep.post(
          API_PATHS.KN_EXPLORE.getStudensByGroup(periodId, campusId),
          data
        );
      },
      getStudentHistoryByIds(url, IdList) {
        return depKnExplore.post(
          API_PATHS.KN_EXPLORE.getHistoryOfStudentsByIds,
          {
            url: url,
            idUser: IdList,
          },
          {
            headers: {
              auth_key: store.state.User.uuid,
            },
          }
        );
      },
      getConfigByLevel(levleId) {
        return depKnExplore.get(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.GET_CONFIG_BY_LEVEL_KN_EXPLORE(
            levleId
          ),
          {
            headers: {
              auth_key: store.state.User.uuid,
            },
          }
        );
      },
      getConfigByStaff() {
        return depKnExplore.get(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.GET_CONFIG_BY_STAFF,
          {
            headers: {
              auth_key: store.state.User.uuid,
            },
          }
        );
      },
      storeConfigKnExplore(data) {
        return depKnExplore.post(
          API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.STORE_CONFIG_KN_EXPLORE,
          data,
          {
            headers: {
              auth_key: store.state.User.uuid,
            },
          }
        );
      },
      storeConfigEngineKnExplore(data) {
        return depKnExplore
          .post(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
              .STORE_CONFIG_ENGINE_KN_EXPLORE,
            data,
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      getWhiteListStudent(levelId) {
        return depKnExplore
          .get(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.GET_WHITE_LIST_STUDENT(
              levelId
            ),
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      getBlackListStudent(levelId) {
        return depKnExplore
          .get(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.GET_BLACK_LIST_STUDENT(
              levelId
            ),
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      getWhiteListStaff() {
        return depKnExplore
          .get(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
              .GET_WHITE_LIST_BY_STAFF,
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      getBlackListStaff() {
        return depKnExplore
          .get(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
              .GET_BLACK_LIST_BY_STAFF,
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      saveDomainWhiteList(data) {
        return depKnExplore
          .post(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
              .STORE_WHITE_LIST_STUDENT,
            data,
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      saveDomainBlackList(data) {
        return depKnExplore
          .post(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
              .STORE_BLACK_LIST_STUDENT,
            data,
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      deleteDomainWhiteList(id) {
        return depKnExplore
          .delete(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.DELETE_WHITE_LIST_DOMAIN(
              id
            ),
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      deleteDomainBlackList(id) {
        return depKnExplore
          .delete(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION.DELETE_BLACK_LIST_DOMAIN(
              id
            ),
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch(() => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      getSearchEnginesKnExplore() {
        return depKnExplore
          .get(API_PATHS.KN_EXPLORE.getSearchEnginesKnExplore, {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((response) => response.data);
      },
      getEnginesStudentKnExplore() {
        return depKnExplore
          .get(API_PATHS.KN_EXPLORE.getEnginesStudentKnExplore, {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((response) => response.data);
      },
      getEnginesStaffKnExplore() {
        return depKnExplore
          .get(API_PATHS.KN_EXPLORE.getEnginesStaffKnExplore, {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((response) => response.data);
      },
      deleteEnginesKnExplore(idEngineUser) {
        return depKnExplore
          .delete(API_PATHS.KN_EXPLORE.deleteEnginesKnExplore(idEngineUser), {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((response) => response.data);
      },
      getBookmarksByGrade(idGrade) {
        return depKnExplore
          .get(API_PATHS.KN_EXPLORE.getBookmarksByGradeEndpoint(idGrade), {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((res) => {
            return res;
          })
          .catch((e) => {
            return e.response.data;
          });
      },
      getBookmarks() {
        return depKnExplore
          .get(API_PATHS.KN_EXPLORE.getBookmarksEndpoint, {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((res) => {
            return res;
          })
          .catch((e) => {
            return e.response.data;
          });
      },
      getCampusBookmarks() {
        return depKnExplore
          .get(API_PATHS.KN_EXPLORE.getCampusBookmarksEndpoint, {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((res) => {
            return res;
          })
          .catch((e) => {
            return e.response.data;
          });
      },
      saveBookmarkByGrade(data) {
        return depKnExplore
          .post(
            API_PATHS.CONFIGURATION.GENERAL_CONFIGURATION
              .STORE_BOOKMARK_KN_EXPLORE,
            data,
            {
              headers: {
                auth_key: store.state.User.uuid,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch((e) => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
      deleteBookmarkEndpoint(idBookmark) {
        return depKnExplore
          .delete(API_PATHS.KN_EXPLORE.deleteBookmarkEndpoint(idBookmark), {
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((response) => response.data);
      },
      deleteBookmarkCategoryEndpoint(data) {
        return depKnExplore
          .delete(API_PATHS.KN_EXPLORE.deleteBookmarkCategoryEndpoint, {
            data: data,
            headers: {
              auth_key: store.state.User.uuid,
            },
          })
          .then((res) => {
            return res;
          })
          .catch((e) => {
            return {
              status: 500,
              message: "Error al guardar la información",
            };
          });
      },
    },
    groups: {
      deleteGroups: function (grupos) {
        return dep.post(API_PATHS.GROUPS_SECTION.DELETE_GROUPS, grupos);
      },
      promoteGroups: function (idGroupInt) {
        return dep.post(API_PATHS.GROUPS_SECTION.PROMOTE, {
          idGroupInt: idGroupInt,
          idPeriod: store.getters.idPeriod,
        });
      },
      getGroupDetail: function (idGroup, idPeriod) {
        let url = API_PATHS.GROUPS_SECTION.GROUP_DETAIL.replace(
          wildCards.groupID,
          idGroup
        ).replace(wildCards.periodID, idPeriod);
        return dep.get(url).then((res) => {
          return res.data;
        });
      },
      getFilters: function () {
        return dep
          .get(
            API_PATHS.GROUPS_SECTION.LEVES_FILTERS.replace(
              wildCards.campusId,
              store.state.User.campus
            ) +
              "&idPeriod=" +
              store.getters.idPeriod
          )
          .then((res) => {
            return res;
          });
      },
      saveGroup: function (data) {
        return dep.post(API_PATHS.GROUPS_SECTION.SAVE_GROUP, data);
      },
      graduate: function (data) {
        return dep.post(
          API_PATHS.GROUPS_SECTION.GRADUATE,
          Object.assign(data, {
            idPeriod: store.getters.idPeriod,
          })
        );
      },
    },
    evaluation: {
      models: {
        deleteModels: function (models) {
          return dep.delete(API_PATHS.EVALUATION.MODELS.DELETE_MODELS, {
            data: models,
          });
        },
        getModelDetail: function (idModel) {
          let url = API_PATHS.EVALUATION.MODELS.MODEL_DETAIL.replace(
            wildCards.modelId,
            idModel
          );
          return dep.get(url).then((res) => {
            return res.data;
          });
        },
        saveModel: function (data) {
          return dep.post(API_PATHS.EVALUATION.MODELS.SAVE_MODEL, data);
        },
      },
    },
    students: {
      getLevelsLight: function (campus) {
        return dep
          .get(
            API_PATHS.STUDENTS_FORM.LEVELS_LIGHT.replace(
              wildCards.campusId,
              campus
            ) +
              "?idPeriod=" +
              store.getters.idPeriod
          )
          .then((res) => {
            return res.data;
          });
      },
      getUserName: function (params, temporalUsernames) {
        return dep
          .post(
            API_PATHS.STUDENTS_FORM.USERNAME_GENERATION + params,
            temporalUsernames
          )
          .then((res) => {
            return res.data;
          });
      },
      save: function (period, students) {
        return dep.post(
          API_PATHS.STUDENTS_FORM.SAVE.replace(wildCards.periodID, period),
          students
        );
      },
    },
    notifications: {
      get(uid) {
        //DEP111
        return dep.get(API_PATHS.NOTIFICATIONS.SAVE + "/" + uid).then((res) => {
          return res.data;
        });
      },
      getCom(uid) {
        //DEP131
        return dep
          .get(API_PATHS.NOTIFICATIONS.MULTICAMPUS_SAVE + "/" + uid)
          .then((res) => {
            return res.data;
          });
      },
      getList() {
        return dep.post(API_PATHS.NOTIFICATIONS.LIST).then((res) => {
          return res.data;
        });
      },
      getMultiList() {
        return dep
          .post(API_PATHS.NOTIFICATIONS.MULTICAMPUS_LIST)
          .then((res) => {
            return res.data;
          });
      },
      delete(notifications) {
        if (typeof notifications == "string") {
          notifications = [notifications];
        }
        return dep.post(API_PATHS.NOTIFICATIONS.DELETE, notifications);
      },
      deleteCom(notifications) {
        if (typeof notifications == "string") {
          notifications = [notifications];
        }
        return dep.post(API_PATHS.NOTIFICATIONS.DELETE_MASIVE, notifications);
      },
      saveNotification(formData, uploadListener) {
        return dep.request({
          url: API_PATHS.NOTIFICATIONS.SAVE,
          headers: {
            "Content-Type": "multipart/form-data;charset=UTF-8",
          },
          method: "POST",
          data: objectToFormData(
            Object.assign(
              {
                idPeriodInt: store.getters.idPeriodInt,
              },
              formData
            )
          ),
          onUploadProgress: uploadListener,
        });
      },
      saveMultiNotification(formData, uploadListener) {
        return dep.request({
          url: API_PATHS.NOTIFICATIONS.MULTICAMPUS_SAVE,
          headers: {
            "Content-Type": "multipart/form-data;charset=UTF-8",
          },
          method: "POST",
          data: objectToFormData(
            Object.assign(
              {
                idPeriodInt: store.getters.idPeriodInt,
              },
              formData
            )
          ),
          onUploadProgress: uploadListener,
        });
      },
      getFilters() {
        return dep
          .get(
            API_PATHS.NOTIFICATIONS.FILTERS +
              "?idPeriodInt=" +
              store.getters.idPeriodInt
          )
          .then((res) => {
            return res.data;
          });
      },
      getSendFilters() {
        return dep
          .get(
            API_PATHS.NOTIFICATIONS.SEND_FILTERS +
              "?idPeriodInt=" +
              store.getters.idPeriodInt
          )
          .then((res) => {
            return res.data;
          });
      },
      getComunicationFilters() {
        return dep
          .get(
            API_PATHS.NOTIFICATIONS.FILTERS +
              API_PATHS.NOTIFICATIONS.MULTI_CAMPUS_FILTERS +
              "?idPeriodInt=" +
              store.getters.idPeriodInt
          )
          .then((res) => {
            return res.data;
          });
      },
      getComunicationSendFilters() {
        return dep
          .get(
            API_PATHS.NOTIFICATIONS.SEND_FILTERS +
              API_PATHS.NOTIFICATIONS.MULTI_CAMPUS_FILTERS +
              "?idPeriodInt=" +
              store.getters.idPeriodInt
          )
          .then((res) => {
            return res.data;
          });
      },
    },
    customSubjects: {
      save(subject) {
        return dep.post(
          API_PATHS.CUSTOM_SUBJECTS.ENDPOINT +
            "?idPeriod=" +
            store.getters.idPeriod,
          subject
        );
      },
      delete(subjectID) {
        return dep.delete(API_PATHS.CUSTOM_SUBJECTS.ENDPOINT + "/" + subjectID);
      },
    },
    callCenter: {
      postGeneralInfo() {
        return dep
          .post(API_PATHS.CALL_CENTER.TRANSACTIONS)
          .then((response) => response.data);
      },
      getBankStatementDetail(userId, periodId, paymentDepositSheetType) {
        return dep
          .get(
            API_PATHS.CALL_CENTER.BANK_STATEMENT_DETAIL(
              userId,
              periodId,
              paymentDepositSheetType
            )
          )
          .then((response) => response.data);
      },
      sendPaymentInvoiceByEmail(emailAddress, paymentId) {
        return dep
          .post(API_PATHS.CALL_CENTER.SEND_PAYMENT_INVOICE_BY_EMAIL, {
            email: emailAddress,
            idPayment: paymentId,
          })
          .then((response) => response.data);
      },
      sendPaymentVoucherByEmail(emailAddress, paymentId) {
        return dep
          .post(API_PATHS.CALL_CENTER.SEND_PAYMENT_VOUCHER_BY_EMAIL, {
            email: emailAddress,
            idPayment: paymentId,
          })
          .then((response) => response.data);
      },
      getPaymentsType() {
        return dep
          .get(API_PATHS.CALL_CENTER.GET_PAYMENT_TYPES)
          .then((response) => response.data);
      },
      generateOxxoPaymentForm(paymentId, data) {
        return dep
          .post(
            API_PATHS.CALL_CENTER.GENERATE_OXXO_PAYMENT_FORM(paymentId),
            data
          )
          .then((response) => response)
          .catch(() => {
            return {
              status: 500,
              message: "Error al generar el formulario de pago",
            };
          });
      },
      getOxxoPaymentInfo(paymentId, data) {
        return dep
          .post(API_PATHS.CALL_CENTER.GET_OXXO_PAYMENT_INFO(paymentId), data)
          .then((response) => response.data);
      },
      generateBankTransferPaymentForm(data) {
        return dep
          .post(API_PATHS.CALL_CENTER.GENERATE_BANK_TRANSFER_FORM, data)
          .then((response) => response)
          .catch((error) => {
            return {
              status: 500,
              message: "Error al generar el formulario de pago",
              data: null,
              error: error.response.data,
            };
          });
      },
      sendPaymentFormByEmail(emailAddress, data) {
        return dep
          .post(
            API_PATHS.CALL_CENTER.SEND_PAYMENT_FORM_BY_EMAIL(emailAddress),
            data
          )
          .then((response) => response.data);
      },
      associatePaymentToRelative(paymentId, relativeId) {
        return dep
          .post(API_PATHS.CALL_CENTER.ADD_RELATIVE, {
            idPayment: paymentId,
            idRelative: relativeId,
          })
          .then((response) => response.data);
      },
      saveUserPaymentConfiguration(data) {
        return dep
          .post(API_PATHS.CALL_CENTER.USER_PAYMENT_CONFIGURATION, data)
          .then((response) => response.data);
      },
      deleteUserPaymentConfiguration(periodId, userId) {
        return dep
          .delete(
            API_PATHS.CALL_CENTER.DELETE_PAYMENT_CONFIGURATION(periodId, userId)
          )
          .then((response) => response.data);
      },
      getUserPaymentConfigurationByPeriod(periodId, userId) {
        return dep
          .get(
            API_PATHS.CALL_CENTER.GET_USER_PAYMENT_CONFIGURATION(
              periodId,
              userId
            )
          )
          .then((response) => response.data);
      },
      getPaymentDetails(paymentId) {
        return dep
          .get(API_PATHS.CALL_CENTER.GET_PAYMENT_DETAILS(paymentId))
          .then((response) => response.data);
      },
      getPaymentCancellationDetails(paymentId) {
        return dep
          .get(API_PATHS.CALL_CENTER.GET_PAYMENT_CANCELLATION_DETAIL(paymentId))
          .then((response) => response.data)
          .catch((error) => {
            return error.response.data;
          });
      },
      cancelPayment(data) {
        return dep
          .post(API_PATHS.CALL_CENTER.CANCEL_PAYMENT, data, {
            headers: {
              "Content-Type": "application/octet-stream",
            },
          })
          .then((response) => response.data);
      },
      getPaymentCancellationDetail(paymentId) {
        return dep
          .get(API_PATHS.CALL_CENTER.PAYMENT_CANCELLATION_DETAIL(paymentId))
          .then((response) => response.data);
      },
      getPaymenyCancellationProcessDetail(paymentId) {
        return dep
          .get(
            API_PATHS.CALL_CENTER.PAYMENY_CANCELLATION_PROCESS_DETAIL(paymentId)
          )
          .then((response) => response.data);
      },
      completeInvoiceVoucher(paymentId) {
        return dep
          .get(
            API_PATHS.CALL_CENTER.CANCELLATION_VOUCHERS.COMPLETE_INVOICE_VOUCHER(
              paymentId
            )
          )
          .then((response) => response.data);
      },
      completeRefundVoucher(paymentId) {
        return dep
          .get(
            API_PATHS.CALL_CENTER.CANCELLATION_VOUCHERS.COMPLETE_REFUND_VOUCHER(
              paymentId
            )
          )
          .then((response) => response.data);
      },
      filters: {
        getCountries() {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.COUNTRIES)
            .then((response) => response.data);
        },
        getStatesByCountry(countryId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.STATES_BY_COUNTRY(countryId))
            .then((response) => response.data);
        },
        getCitiesByState(stateId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.CITIES_BY_STATE(stateId))
            .then((response) => response.data);
        },
        getSchools(countryId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.SCHOOLS(countryId))
            .then((response) => response.data);
        },
        getCampuses(schoolId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.CAMPUSES(schoolId))
            .then((response) => response.data);
        },
        getPeriods(countryId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.PERIODS(countryId))
            .then((response) => response.data);
        },
        getPeriodsByStudentId(studentId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.PERIODS_BY_STUDENT(studentId))
            .then((response) => response.data);
        },
        getCampusesByCountryAndCompany(countryId, companyId) {
          return dep
            .get(
              API_PATHS.CALL_CENTER.FILTERS.CAMPUSES_BY_COMPANY_AND_COUNTRY(
                countryId,
                companyId
              )
            )
            .then((response) => response.data);
        },
        getCompanies(countryId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.COMPANIES(countryId))
            .then((response) => response.data);
        },
        getDiscountReasons() {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.DISCOUNT_REASONS)
            .then((response) => response.data);
        },
        getPricesByPeriodAndUser(periodId, userId) {
          return dep
            .get(
              API_PATHS.CALL_CENTER.FILTERS.PRICES_BY_PERIOD_AND_USER(
                periodId,
                userId
              )
            )
            .then((response) => response.data);
        },
        getActiveCampuses() {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.ACTIVE_CAMPUSES)
            .then((response) => response.data);
        },
        getCampusLevels(campusId) {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.CAMPUS_LEVELS(campusId))
            .then((response) => response.data);
        },
        getActiveCancellationReasons() {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.ACTIVE_CANCELLATION_REASONS)
            .then((response) => response.data);
        },
        getBanksCatalog() {
          return dep
            .get(API_PATHS.CALL_CENTER.FILTERS.BANKS_CATALOG)
            .then((response) => response.data);
        },
        getRelativeEmails(userId) {
          return dep
            .get(
              API_PATHS.CALL_CENTER.FILTERS.RELATIVE_EMAILS_BY_USER_ID(userId)
            )
            .then((response) => response.data);
        },
      },
      relativeCreation: {
        createRelative(data) {
          return dep
            .post(API_PATHS.CALL_CENTER.RELATIVE_CREATION.CREATE_RELATIVE, data)
            .then((response) => response.data);
        },
        saveInvoiceInfo(data) {
          return dep
            .post(
              API_PATHS.CALL_CENTER.RELATIVE_CREATION.SAVE_INVOICE_INFORMATION,
              data
            )
            .then((response) => response.data);
        },
        saveShipmentInfo(data) {
          return dep
            .post(
              API_PATHS.CALL_CENTER.RELATIVE_CREATION.SAVE_SHIPMENT_INFORMATION,
              data
            )
            .then((response) => response.data);
        },
        saveStudentAssociation(relativeId, studentsArray) {
          return dep
            .post(
              API_PATHS.CALL_CENTER.RELATIVE_CREATION.SAVE_STUDENTS_ASSOCIATION(
                relativeId
              ),
              studentsArray
            )
            .then((response) => response.data);
        },
      },
      newPayment: {
        deleteFiles(files) {
          return dep
            .delete(API_PATHS.CALL_CENTER.NEW_PAYMENT_MODAL.DELETE_FILES, {
              data: files,
            })
            .then((response) => response.data);
        },
        getSatPaymentTypes() {
          return dep
            .get(API_PATHS.CALL_CENTER.NEW_PAYMENT_MODAL.SAT_PAYMENT_TYPES)
            .then((response) => response.data);
        },
        getPaymentForStudentsByDate(paymentDate, students) {
          return dep
            .post(
              API_PATHS.CALL_CENTER.NEW_PAYMENT_MODAL
                .GET_PAYMENT_AMOUNT_BY_DATE_FOR_STUDENTS,
              {
                paymentDate,
                students,
              }
            )
            .then((response) => response.data);
        },
        savePayment(request) {
          return dep
            .post(API_PATHS.CALL_CENTER.NEW_PAYMENT_MODAL.SAVE_PAYMENT, request)
            .then((response) => response.data);
        },
        getStudentByName(studentName, idCampus) {
          return dep
            .post(API_PATHS.WEBON_TABLES.CALL_CENTER.STUDENTS_PAYMENT_FORM, {
              text: studentName,
              pageSize: 10,
              pageNumber: 1,
              sortName: "firstSurname",
              sortOders: "desc",
              idCampus,
            })
            .then((response) => response.data);
        },
      },
      cfdi: {
        personKinds() {
          return dep
            .get(API_PATHS.CALL_CENTER.CFDI.PERSON_KINDS)
            .then((response) => response.data);
        },
        cfdiUses(personKind) {
          return dep
            .get(API_PATHS.CALL_CENTER.CFDI.USES(personKind))
            .then((response) => response.data);
        },
        taxRegimens(personKind, cfdiUse) {
          return dep
            .get(API_PATHS.CALL_CENTER.CFDI.TAX_REGIMENS(personKind, cfdiUse))
            .then((response) => response.data);
        },
      },
    },
  };

  var newAPI = Object.assign({}, API, {
    store,
  });
  return newAPI;
}
